/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import { Navigation } from "@/components/customCopmonent/landingSection/navigation";
import { FooterSection } from "@/components/customCopmonent/landingSection/footer-section";
import CircularGallery from "@/components/customCopmonent/CircularGallery";
import DotGrid from "@/components/customCopmonent/DotGrid";
import { PageHeaderHero, PAGE_HERO_CLASS } from "@/components/customCopmonent/Text/PageHeaderHero";
import { SectionWrapper } from "../Clientele.page-primitives";
import { PageHeader } from "@/components/customCopmonent/Text/PageHeader";
import { RevealOnScroll } from "@/components/SpecialProjectsPage.primitives";

import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useTranslation } from "react-i18next";
import Seo from "@/components/Seo";
import { useIsMobile } from "@/hooks/hooks/use-mobile";
import {
	IndustrySectionProduct,
	IndustrySectionApplication,
} from "@/components/customCopmonent/IndustryCardsAP";

// Register ScrollTrigger
if (typeof window !== "undefined") {
	gsap.registerPlugin(ScrollTrigger);
}

const PlasticInjectionMolding = () => {
	const { t } = useTranslation();
	const isMobile = useIsMobile();

	const subIndustryImages = [
		"/images/industriesPhotos/PlasticInjectionMolding/SubIndustries/Injection_Molding_Machines.webp",
		"/images/industriesPhotos/PlasticInjectionMolding/SubIndustries/Mold_Cooling_Systems.webp",
		"/images/industriesPhotos/PlasticInjectionMolding/SubIndustries/Plastic_Processing_Plants.webp",
		"/images/industriesPhotos/PlasticInjectionMolding/SubIndustries/Polymer_Manufacturing_Units.webp",
		"/images/industriesPhotos/PlasticInjectionMolding/SubIndustries/automotive-3.jpg",
	];

	const applicationImages = [
		"/images/industriesPhotos/PlasticInjectionMolding/Application/Mold_Cooling_Systems.webp",
		"/images/industriesPhotos/PlasticInjectionMolding/Application/Hydraulic_Oil_Cooling.webp",
		"/images/industriesPhotos/PlasticInjectionMolding/Application/Process_Temperature_Controlwebp.webp",
		"/images/industriesPhotos/PlasticInjectionMolding/Application/Chiller_System_Heat_Exchange.webp",
		"/images/industriesPhotos/PlasticInjectionMolding/Application/Machine BarrelCooling.webp",
		"/images/industriesPhotos/PlasticInjectionMolding/Application/Hot_Runner_System_Cooling.jpg",
	];

	const subIndustryTexts = t(
		"industryPages.plasticInjectionMolding.subIndustries.items",
		{ returnObjects: true },
	) as string[];
	const applicationItems = t(
		"industryPages.plasticInjectionMolding.applications.items",
		{ returnObjects: true },
	) as { title: string; description: string }[];

	const pageData = {
		title: t("industryPages.plasticInjectionMolding.title"),
		bgimage: "/images/header/plastic.webp",

		description: t("industryPages.plasticInjectionMolding.tagline"),

		meta: t("industryPages.plasticInjectionMolding.meta", {
			returnObjects: true,
		}) as string[],

		subIndustries: {
			title: t("industryPages.plasticInjectionMolding.subIndustries.title"),

			industries: subIndustryImages.map((image, i) => ({
				image,
				text: subIndustryTexts[i],
			})),
		},

		applications: {
			title: t("industryPages.plasticInjectionMolding.applications.title"),

			applications: applicationImages.map((image, i) => ({
				image,
				title: applicationItems[i].title,
				description: applicationItems[i].description,
			})),
		},
	};

	return (
		<>
			<Seo
				titleKey="industryPages.plasticInjectionMolding.seo.title"
				descriptionKey="industryPages.plasticInjectionMolding.seo.description"
				path="/industries/plastic-injection-molding"
			/>
			<Navigation />
			<SectionWrapper className={PAGE_HERO_CLASS}>
				<div className="absolute inset-0 ">
					{" "}
					<div
						className="absolute bottom-3 inset-0 opacity-35 scale-105"
						style={{
							backgroundImage: `url(${pageData.bgimage})`,
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					/>
					<DotGrid
						dotSize={4}
						gap={15}
						baseColor="#3b0092"
						activeColor="#f09a38"
						proximity={100}
						shockRadius={200}
						shockStrength={3}
						resistance={750}
						returnDuration={1.5}
					/>
				</div>
				<PageHeaderHero
					// align="center"
					title={pageData.title}
					description={pageData.description}
					meta={pageData.meta}
				/>
			</SectionWrapper>
			<SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				{" "}
				<div className="relative flex flex-col items-center justify-center ">
					{/* ===== HEADER ===== */}
					<RevealOnScroll>
						<PageHeader
							title={pageData.subIndustries.title}
							align="center"
							className="py-6 text-center items-center "
						/>
					</RevealOnScroll>
				</div>
				<div className="relative h-[360px] sm:h-[460px] lg:h-[600px]">
					<CircularGallery
						items={pageData.subIndustries.industries}
						textColor="#000"
						borderRadius={0.05}
						bend={isMobile ? 0 : -3}
						scrollSpeed={1.5}
						scrollEase={0.05}
					/>
				</div>
			</SectionWrapper>
			<SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				<IndustrySectionApplication
					applications={pageData.applications.applications}
					title={pageData.applications.title}
				/>{" "}
			</SectionWrapper>
			{/* <SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				<IndustrySectionProduct
					applications={pageData.products.products}
					title={pageData.products.title}
					description={pageData.products.description}
				/>{" "}
			</SectionWrapper> */}
			<FooterSection />
		</>
	);
};

export default PlasticInjectionMolding;
